module.exports = __webpack_public_path__ + "static/img/3.316ae17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/4/3.png
// module id = sPlZ
// module chunks = 0